<template>
    <div id="stepcontent">
        <div id="title">
            <h2>Dados gerais</h2>
            <p>Preencha com os dados do empréstimo e do imóvel</p>
        </div>

        <div id="formblock">

            <div>
                <div :class="{'badinput': bad(stepdata.finalidade)}" class="input-line cursor-pointer" @click="ddopen !== 'finalidade' ? ddopen = 'finalidade': ddopen = null">
                    <div class="input-title">
                        <p>Finalidade*</p>
                    </div>

                    <div class="input-field">
                        <p v-html="stepdata.finalidade" ></p>
                    </div>

                    <div  class="input-icon">
                        <img :class="{'flip': ddopen === 'finalidade', 'unflip': ddopen !== 'finalidade'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                    </div>
                </div>
                <transition name="slide-fade">
                    <div v-if="ddopen === 'finalidade'" class="input-expanded">
                        <p v-for="i in finalidades" class="expanded-line" @click="stepdata.finalidade = i; ddopen = null;">{{i}}</p>

                    </div>
                </transition>
            </div>

            <div>
                <div :class="{'badinput': bad(stepdata.tipo)}" class="input-line cursor-pointer" @click="ddopen !== 'tipo' ? ddopen = 'tipo': ddopen = null" >
                    <div class="input-title">
                        <p>Tipo de Habitação*</p>
                    </div>

                    <div class="input-field">
                        <p v-html="stepdata.tipo" ></p>
                    </div>

                    <div class="input-icon">
                        <img :class="{'flip': ddopen === 'tipo', 'unflip': ddopen !== 'tipo'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                    </div>
                </div>
                <transition name="slide-fade">
                    <div v-if="ddopen === 'tipo'" class="input-expanded">
                        <p v-for="i in tipos" class="expanded-line" @click="stepdata.tipo = i; ddopen = null;">{{i}}</p>
                    </div>
                </transition>
            </div>

            <div>
                <div :class="{'badinput': bad(stepdata.destino)}" class="input-line cursor-pointer" @click="ddopen !== 'destino' ? ddopen = 'destino': ddopen = null">
                    <div class="input-title">
                        <p>Destino da Habitação*</p>
                    </div>

                    <div class="input-field">
                        <p v-html="stepdata.destino" ></p>
                    </div>

                    <div  class="input-icon">
                        <img :class="{'flip': ddopen === 'destino', 'unflip': ddopen !== 'destino'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                    </div>
                </div>
                <transition name="slide-fade">
                    <div v-if="ddopen === 'destino'" class="input-expanded">
                        <p v-for="i in destinos" class="expanded-line" @click="stepdata.destino = i; ddopen = null;">{{i}}</p>
                    </div>
                </transition>
            </div>

            <div :class="{'badinput': bad(stepdata.localidade)}" class="input-line">
                <div class="input-title">
                    <p>Localidade*</p>
                </div>

                <div class="input-field">
                    <input type="text" v-model="stepdata.localidade">
                </div>

                <div class="input-icon">
<!--
                    <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
-->
                </div>
            </div>

            <div>
                <div :class="{'badinput': bad(stepdata.distrito)}" class="input-line cursor-pointer" @click="ddopen !== 'distrito' ? ddopen = 'distrito': ddopen = null">
                    <div class="input-title">
                        <p>Distrito*</p>
                    </div>

                    <div class="input-field">
                        <p v-html="stepdata.distrito" ></p>
                    </div>

                    <div  class="input-icon">
                        <img :class="{'flip': ddopen === 'distrito', 'unflip': ddopen !== 'distrito'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                    </div>
                </div>
                <transition name="slide-fade">
                    <div v-if="ddopen === 'distrito'" class="input-expanded">
                        <p v-for="i in distritos" class="expanded-line" @click="stepdata.distrito = i; ddopen = null;">{{i}}</p>
                    </div>
                </transition>
            </div>

            <div :class="{'badinput': bad(stepdata.montante_emprestimo)}" class="input-line">
                <div class="input-title">
                    <p>Montante de Empréstimo*</p>
                </div>

                <div class="input-field">
                    <money v-model="stepdata.montante_emprestimo" v-bind="money"></money>
                </div>

                <div class="input-icon">
                    €
                </div>
            </div>

            <div :class="{'badinput': bad(stepdata.valor_compra)}" class="input-line">
                <div class="input-title">
                    <p>Valor de compra*</p>
                </div>

                <div class="input-field">
                    <money v-model="stepdata.valor_compra" v-bind="money" @blur.native="fixValor"></money>
                </div>

                <div class="input-icon">
                    €
                </div>
            </div>

            <div>
                <div :class="{'badinput': bad(stepdata.prazo)}" class="input-line">
                    <div class="input-title">
                        <p>Prazo de empréstimo (anos)*</p>
                    </div>

                    <div class="input-field">
                        <input @blur="fixPrazo" v-model="stepdata.prazo" type="text">
                    </div>

                    <div class="input-icon">
                    </div>

                </div>

            </div>

            <div>
                <div :class="{'badinput': bad(stepdata.proponente)}" class="input-line cursor-pointer" style="margin-top:1.5rem;" @click="ddopen !== 'proponente' ? ddopen = 'proponente': ddopen = null">
                    <div class="input-title">
                        <p>№ de proponentes*</p>
                    </div>

                    <div class="input-field">
                        <p v-html="stepdata.proponente"> </p>
                    </div>

                    <div  class="input-icon">
                        <img :class="{'flip': ddopen === 'proponente', 'unflip': ddopen !== 'proponente'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                    </div>
                </div>
                <transition name="slide-fade">
                    <div v-if="ddopen === 'proponente'" class="input-expanded">
                        <p v-for="i in 2" class="expanded-line" @click="stepdata.proponente = i; ddopen = null;">{{i}}</p>
                    </div>
                </transition>
            </div>

            <div>
                <div :class="{'badinput': bad(stepdata.fiador)}" class="input-line cursor-pointer" style="margin-top:1.5rem;" @click="ddopen !== 'fiador' ? ddopen = 'fiador': ddopen = null">
                    <div class="input-title">
                        <p>Tem fiadores?*</p>
                    </div>

                    <div class="input-field">
                        <p v-html="stepdata.fiador"> </p>
                    </div>

                    <div  class="input-icon">
                        <img :class="{'flip': ddopen === 'fiador', 'unflip': ddopen !== 'fiador'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                    </div>
                </div>
                <transition name="slide-fade">
                    <div v-if="ddopen === 'fiador'" class="input-expanded">
                        <p v-for="i in fiadores" class="expanded-line" @click="stepdata.fiador = i; ddopen = null;">{{i}}</p>
                    </div>
                </transition>
            </div>


        </div>


    </div>

</template>
<script>
import { Money } from "v-money";

export default {
  components: {
    Money
  },

  props: ["stepdata", "steps", "submitted"],

  data() {
    return {
      finalidades: [
        "Aquisição",
        "Construção",
        "Transferência de crédito",
        "Troca de casa"
      ],
      tipos: ["Apartamento", "Vivenda", "Moradia Geminada"],
      destinos: ["Habitação Própria Permanente", "Habitação Secundária"],
      distritos: [
        "Aveiro",
        "Beja",
        "Braga",
        "Bragança",
        "Castelo Branco",
        "Coimbra",
        "Évora",
        "Faro",
        "Guarda",
        "Ilha da Madeira",
        "Ilha de Porto Santo",
        "Leiria",
        "Lisboa",
        "Portalegre",
        "Porto",
        "Santarém",
        "Setúbal",
        "Viana do Castelo",
        "Vila Real",
        "Viseu",
        "Outro"
      ],
      fiadores: ["Não", "1", "2"],

      ddopen: null,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false
      }
    };
  },

  computed: {
    missingField() {
      console.log(
        !this.stepdata.finalidade,
        !this.stepdata.tipo,
        !this.stepdata.destino,
        !this.stepdata.localidade,
        !this.stepdata.distrito,
        !this.stepdata.montante_emprestimo,
        !this.stepdata.valor_compra,
        !this.stepdata.prazo,
        !this.stepdata.proponente,
        !this.stepdata.fiador
      );

      return (
        !this.stepdata.finalidade ||
        !this.stepdata.tipo ||
        !this.stepdata.destino ||
        !this.stepdata.localidade ||
        !this.stepdata.distrito ||
        !this.stepdata.montante_emprestimo ||
        !this.stepdata.valor_compra ||
        !this.stepdata.prazo ||
        !this.stepdata.proponente ||
        !this.stepdata.fiador
      );
    }
  },

  methods: {
    fixPrazo() {
      this.stepdata.prazo.match("^[0-9][0-9]$")
        ? null
        : (this.stepdata.prazo = 10);
      parseInt(this.stepdata.prazo) < 10 ? (this.stepdata.prazo = "10") : null;
      parseInt(this.stepdata.prazo) > 40 ? (this.stepdata.prazo = "40") : null;
    },

    fixValor() {
      this.stepdata.montante_emprestimo > this.stepdata.valor_compra
        ? (this.stepdata.montante_emprestimo = this.stepdata.valor_compra)
        : null;
    },

    bad(val) {
      return this.submitted && !val;
    }
  }
};
</script>
<style lang="scss" scoped>
.badinput {
  border: solid 1px #e90054 !important;
}

#stepcontent {
  position: relative;
  text-align: center;
}
#title {
  padding: 2rem 0;
}
#title h2 {
  color: #2d3256;
  font-weight: 900;
  font-size: 2.5rem;
}
#title p {
  color: #4f4f4f;
  font-weight: 400;
  font-size: 1.25rem;
}

$input-width: 45rem;

#formblock {
  max-width: $input-width;
  margin: auto;
}

$font-size: 1.125rem;
$input-line-height: 3rem;
.input-line {
  border: solid 1px #f5f5f5;
  position: relative;
  background-color: #ffffff;
  width: 100%;
  height: $input-line-height;
  display: flex;
  margin: 0.75rem;
}

.input-expanded {
  position: absolute;
  background-color: #ffffff;
  width: 100%;
  margin: -0.75rem 0.75rem 0.75rem;
  color: black;
  padding: 0.5rem 1rem 0;
  max-width: $input-width;
  z-index: 4;
  max-height: $input-line-height * 0.8 * 5;
  overflow-y: auto;
}

.expanded-line {
  position: relative;
  height: $input-line-height * 0.8;
  line-height: $input-line-height * 0.8;
  font-size: $font-size * 0.8;
  display: flex;
  padding-left: 0.75rem;
  border-bottom: solid 1px #f1f1f1;
  cursor: pointer;
}

.expanded-line:hover {
  color: white !important;
  background-color: #e90054 !important;
}

.expanded-line:last-child {
  border-bottom: none;
}

.input-title {
  line-height: $input-line-height;
  padding: 0 0 0 1.25rem;
  color: black;
  font-size: $font-size;
  flex-grow: 1;
  white-space: nowrap;
}

.input-line p {
  text-align: left;
}

.input-title {
  line-height: $input-line-height;
  padding: 0 1.25rem;
  color: black;
  font-size: $font-size;
  flex-grow: 1;
  white-space: nowrap;
}

.input-field {
  //line-height:$input-line-height;
  padding: 0.675rem 1rem;
  color: black;
  font-size: $font-size;
  flex-grow: 10;
}

.input-field input {
  //line-height:$input-line-height;
  text-align: right;
  color: #4a4a4a;
  cursor: text;
  width: 100%;
  font-weight: 600;
  outline: none !important;
}

.input-field p {
  //line-height:$input-line-height;
  text-align: right;
  color: #4a4a4a;
  cursor: pointer;
  width: 100%;
  font-weight: 600;
  outline: none !important;
}

.cursor-pointer .input-field input {
  cursor: pointer;
}

.input-icon {
  line-height: 1rem;
  padding: 1rem 0.5rem;
  color: black;
  width: 2rem;
  min-width: 22px;
}

.input-icon img {
  cursor: pointer;
}

.flip {
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  transform: rotate(180deg);
}

.unflip {
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  transform: rotate(0deg);
}
</style>



// WEBPACK FOOTER //
// src/pages/CreditoHabitacao/Step1.vue